<template>
    <div class="history tab-panel padded">
        <div v-if="items.length > 0" class="m-3">
            <div v-for="item in items" class="d-flex align-items-center fs-small mb-3">
                <div class="pr-4">
                    <img :src="'/static/images/' + item.image" alt="">
                </div>
                <div class="flex-all">
                    <strong>{{ item.name }}</strong> {{ item.event }}
                </div>
                <div class="dark ml-auto">
                    {{ item.when }}
                </div>
            </div>
        </div>
        
        <p v-else class="m-3">You have no information available yet.</p>

        <div class="options bg-lighter dark py-3 px-5 fs-small">
            <span class="bold">Settings</span>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            items: function() {
                return [
                    {
                        name: 'Joana Santos',
                        image: 'avatar.png',
                        event: 'added new reservation: XK6123 - Caves & Coastline 09:00.',
                        when: '1 days ago',
                    },
                    {
                        name: 'Joana Santos',
                        image: 'avatar.png',
                        event: 'added new extras to this reservation: 3 top decks, 1 top deck (infant).',
                        when: '3 days ago',
                    },
                    {
                        name: 'Joana Santos',
                        image: 'avatar.png',
                        event: 'set check-in status to: 2 check-in, 1 no-show.',
                        when: '5 days ago',
                    },
                ]
            }
        }
    }
</script>

<style lang="scss">
    .history {
        .options {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
        }
    }
</style>


// WEBPACK FOOTER //
// ViewHistory.vue?c8a6a9a8